(function ($) {
	'use strict';

	$(document).ready(function () {

		const video = '<video \
		id="my-video" \
		class="video-js vjs-theme-sea" \
		controls \
		preload="auto" \
		width="480" \
		height="360" \
		poster="" \
		data-setup="{}"> \
		<source src="{$url}" type="video/mp4" /> \
		<p class="vjs-no-js"> \
			To view this video please enable JavaScript, and consider upgrading to a \
			web browser that \
			<a href="https://videojs.com/html5-video-support/" target="_blank" \
								>supports HTML5 video</a> \
							</p> \
						  </video>';

	$('.video-playback').on('click', function (e) {
		e.preventDefault();
		const videoUrl = $(this).data('video');
		const title = $(this).data('title');
		const content = video.replace('{$url}', videoUrl);
		let player;
		const modal = new jBox('Modal', {
			width: 520,
			height: 390,
			title: title + ' video',
			content: content,
			closeButton: "title",
			onCloseComplete: function () {
				if (player) {
                    player.dispose();
					player = null;
                }
				modal.destroy();
			},
			onOpen: function () {
				player = videojs("my-video");
			},
			animation: "slide"
		});
		modal.open();
		return false;
	});

	$('.video-description').on('click', function (e) {
		e.preventDefault();
		const videoId = $(this).data('product');
		const ajaxurl = PWB.ajax_url;
		const data = { 'action': 'pwb_product_description', 'id': videoId, 'nonce': PWB.nonce };
		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: data,
			success: function (result) {
				const modal = new jBox('Modal', {
					width: 500,
					height: 320,
					title: 'Product Info',
					content: result,
					closeButton: "title",
					onCloseComplete: function () {
						modal.destroy();
					},
					animation: "slide"
				});
				modal.open();
			},
		});
		return false;
	});

});

})(jQuery);